import React, { useState, useEffect } from "react";
import './Footer.css';

const Footer = () => {

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();

    return (
        <div className="footerDiv">
            <p className="text1footer">Made with lots of love by Escape Room Bragança © {currentYear}</p>
        </div>
    );
};

export default Footer;